export const allPlayers = [
    {
        "username": "nimish",
        "score": 2770
    },
    {
        "username": "horcrux",
        "score": 1820
    },
    {
        "username": "milloii",
        "score": 1680
    },
    {
        "username": "pridevta",
        "score": 1500
    },
    {
        "username": "Outrun",
        "score": 1500
    },
    {
        "username": "Gligy",
        "score": 1460
    },
    {
        "username": "CoolGirl2019",
        "score": 990
    },
    {
        "username": "itsayush",
        "score": 990
    },
    {
        "username": "Thaman",
        "score": 990
    },
    {
        "username": "alok27a",
        "score": 990
    },
    {
        "username": "bhavye_27",
        "score": 990
    },
    {
        "username": "nanduri_jv",
        "score": 990
    },
    {
        "username": "prasoonsoni",
        "score": 990
    },
    {
        "username": "Homeostasis",
        "score": 990
    },
    {
        "username": "sukesh04",
        "score": 990
    },
    {
        "username": "Perpetually_smiling",
        "score": 950
    },
    {
        "username": "Smurfwaj",
        "score": 920
    },
    {
        "username": "Likkiii_2.0",
        "score": 920
    },
    {
        "username": "GGman100",
        "score": 870
    },
    {
        "username": "shivamMundada",
        "score": 870
    },
    {
        "username": "Sagefell29",
        "score": 850
    },
    {
        "username": "secreto",
        "score": 820
    },
    {
        "username": "butyouresoloud",
        "score": 770
    },
    {
        "username": "isimpforcutecats",
        "score": 770
    },
    {
        "username": "Godwaj",
        "score": 760
    },
    {
        "username": "memehul",
        "score": 760
    },
    {
        "username": "IDK_bro",
        "score": 750
    },
    {
        "username": "nithya67",
        "score": 750
    },
    {
        "username": "swathika",
        "score": 740
    },
    {
        "username": "usainbolt9000",
        "score": 740
    },
    {
        "username": "Nene",
        "score": 710
    },
    {
        "username": "whatev",
        "score": 710
    },
    {
        "username": "soulslayer",
        "score": 710
    },
    {
        "username": "tanyawarrier",
        "score": 700
    },
    {
        "username": "Adhie5h",
        "score": 650
    },
    {
        "username": "hitarth2004",
        "score": 650
    },
    {
        "username": "divyanshh",
        "score": 650
    },
    {
        "username": "Bharath_03brad",
        "score": 610
    },
    {
        "username": "escapegladys",
        "score": 600
    },
    {
        "username": "Aravind147",
        "score": 600
    },
    {
        "username": "James_nolastname",
        "score": 590
    },
    {
        "username": "Nask",
        "score": 590
    },
    {
        "username": "Ana",
        "score": 550
    },
    {
        "username": "psai11",
        "score": 550
    },
    {
        "username": "horseman",
        "score": 550
    },
    {
        "username": "KandiceC",
        "score": 530
    },
    {
        "username": "Abi2012",
        "score": 520
    },
    {
        "username": "usainbolt",
        "score": 510
    },
    {
        "username": "Savitar",
        "score": 500
    },
    {
        "username": "dhruvil237",
        "score": 480
    },
    {
        "username": "rahul124",
        "score": 480
    },
    {
        "username": "Sachin_10",
        "score": 470
    },
    {
        "username": "suraj_0956",
        "score": 470
    },
    {
        "username": "iWILLwin",
        "score": 460
    },
    {
        "username": "3209404030",
        "score": 460
    },
    {
        "username": "PrayulKumar",
        "score": 460
    },
    {
        "username": "projukta",
        "score": 450
    },
    {
        "username": "rohugr8",
        "score": 450
    },
    {
        "username": "sultaan",
        "score": 450
    },
    {
        "username": "jyo284",
        "score": 440
    },
    {
        "username": "vidhi",
        "score": 420
    },
    {
        "username": "zee2002",
        "score": 420
    },
    {
        "username": "adhi",
        "score": 410
    },
    {
        "username": "Zoozoo",
        "score": 400
    },
    {
        "username": "ognjen011",
        "score": 400
    },
    {
        "username": "Rudraksh18",
        "score": 400
    },
    {
        "username": "555",
        "score": 400
    },
    {
        "username": "ritwijkp",
        "score": 400
    },
    {
        "username": "Bala",
        "score": 400
    },
    {
        "username": "YESanubhav08",
        "score": 400
    },
    {
        "username": "dt_soham09",
        "score": 400
    },
    {
        "username": "Agent47",
        "score": 400
    },
    {
        "username": "misosupa",
        "score": 400
    },
    {
        "username": "parker_730",
        "score": 400
    },
    {
        "username": "tisha",
        "score": 400
    },
    {
        "username": "Kunchakuri",
        "score": 400
    },
    {
        "username": "dschuh",
        "score": 380
    },
    {
        "username": "kxvya",
        "score": 380
    },
    {
        "username": "aanpanman",
        "score": 360
    },
    {
        "username": "storm.earth.fire",
        "score": 360
    },
    {
        "username": "candy123",
        "score": 360
    },
    {
        "username": "EdwardNygma",
        "score": 360
    },
    {
        "username": "Ddaeng",
        "score": 360
    },
    {
        "username": "madmax7502",
        "score": 360
    },
    {
        "username": "fdhdfh",
        "score": 360
    },
    {
        "username": "SlytherclawPadawan",
        "score": 360
    },
    {
        "username": "pp_gogo",
        "score": 350
    },
    {
        "username": "im_saatvik",
        "score": 340
    },
    {
        "username": "youaresalty",
        "score": 330
    },
    {
        "username": "ananya2000",
        "score": 330
    },
    {
        "username": "Pera",
        "score": 330
    },
    {
        "username": "AnaM",
        "score": 320
    },
    {
        "username": "anubhav08",
        "score": 320
    },
    {
        "username": "ShadowTex",
        "score": 320
    },
    {
        "username": "aaryankotharii",
        "score": 320
    },
    {
        "username": "RusticBlueRival",
        "score": 310
    },
    {
        "username": "rujulsrivastava",
        "score": 300
    },
    {
        "username": "Phoenix",
        "score": 300
    },
    {
        "username": "covfebeforecode",
        "score": 300
    },
    {
        "username": "Saint",
        "score": 300
    },
    {
        "username": "brinjalbaba",
        "score": 300
    },
    {
        "username": "Djchinothellya",
        "score": 300
    },
    {
        "username": "amlfarhad",
        "score": 300
    },
    {
        "username": "shamil",
        "score": 300
    },
    {
        "username": "vritika_sharma",
        "score": 300
    },
    {
        "username": "Chief_Adi",
        "score": 300
    },
    {
        "username": "Pikel1997",
        "score": 300
    },
    {
        "username": "Catlyst",
        "score": 300
    },
    {
        "username": "dracarys",
        "score": 300
    },
    {
        "username": "Sid007",
        "score": 300
    },
    {
        "username": "20BIT0203",
        "score": 300
    },
    {
        "username": "tarunika",
        "score": 300
    },
    {
        "username": "Shraddhasuman",
        "score": 300
    },
    {
        "username": "20BBS0196",
        "score": 300
    },
    {
        "username": "utkarsh350",
        "score": 300
    },
    {
        "username": "hocrux2",
        "score": 300
    },
    {
        "username": "uio",
        "score": 300
    },
    {
        "username": "aaryankothariii",
        "score": 300
    },
    {
        "username": "PUZZLEDRIFTER",
        "score": 300
    },
    {
        "username": "Gursehaj",
        "score": 300
    },
    {
        "username": "braden",
        "score": 300
    },
    {
        "username": "salt57",
        "score": 300
    },
    {
        "username": "Joe_Biden",
        "score": 290
    },
    {
        "username": "slayerar",
        "score": 290
    },
    {
        "username": "shady1878",
        "score": 280
    },
    {
        "username": "NOTanubhav08",
        "score": 280
    },
    {
        "username": "arrnavvv",
        "score": 280
    },
    {
        "username": "sanjna_19",
        "score": 260
    },
    {
        "username": "20BCE0528",
        "score": 260
    },
    {
        "username": "rshbart",
        "score": 260
    },
    {
        "username": "Thisismy7thaccount",
        "score": 260
    },
    {
        "username": "Batman",
        "score": 260
    },
    {
        "username": "Nahemah",
        "score": 260
    },
    {
        "username": "erinkp",
        "score": 260
    },
    {
        "username": "ryangomez98",
        "score": 240
    },
    {
        "username": "Parker",
        "score": 240
    },
    {
        "username": "bastrdknt",
        "score": 220
    },
    {
        "username": "karan",
        "score": 220
    },
    {
        "username": "luanr",
        "score": 220
    },
    {
        "username": "YAAAASH",
        "score": 220
    },
    {
        "username": "rowhan",
        "score": 200
    },
    {
        "username": "advit2203",
        "score": 200
    },
    {
        "username": "rylock5858",
        "score": 200
    },
    {
        "username": "Dw33p",
        "score": 200
    },
    {
        "username": "MishuAnubis",
        "score": 200
    },
    {
        "username": "Likkiii",
        "score": 200
    },
    {
        "username": "Necromancer",
        "score": 200
    },
    {
        "username": "Nash",
        "score": 200
    },
    {
        "username": "Kartik4466",
        "score": 200
    },
    {
        "username": "TalibanBhagao",
        "score": 200
    },
    {
        "username": "Munish",
        "score": 200
    },
    {
        "username": "agniva_basak",
        "score": 200
    },
    {
        "username": "dubdeeber",
        "score": 200
    },
    {
        "username": "battlemonger",
        "score": 200
    },
    {
        "username": "ameeshagkm",
        "score": 200
    },
    {
        "username": "VAIBHAV",
        "score": 200
    },
    {
        "username": "ragesh",
        "score": 200
    },
    {
        "username": "teodoricalepotica",
        "score": 200
    },
    {
        "username": "negative_index_",
        "score": 200
    },
    {
        "username": "SiDarthVader",
        "score": 200
    },
    {
        "username": "bradwaj",
        "score": 200
    },
    {
        "username": "shhsgghdfg",
        "score": 200
    },
    {
        "username": "20BCE2204",
        "score": 200
    },
    {
        "username": "gjusepperossi",
        "score": 200
    },
    {
        "username": "Ethan",
        "score": 180
    },
    {
        "username": "Akshara",
        "score": 180
    },
    {
        "username": "autho.r",
        "score": 180
    },
    {
        "username": "HUM",
        "score": 180
    },
    {
        "username": "nzvincent",
        "score": 180
    },
    {
        "username": "harshita165",
        "score": 180
    },
    {
        "username": "MysticBanjo",
        "score": 180
    },
    {
        "username": "bri",
        "score": 170
    },
    {
        "username": "adilsanad",
        "score": 160
    },
    {
        "username": "tanyajanaswamy",
        "score": 160
    },
    {
        "username": "rishabh",
        "score": 160
    },
    {
        "username": "karyashh",
        "score": 160
    },
    {
        "username": "skydiamondmu",
        "score": 160
    },
    {
        "username": "Njberry",
        "score": 160
    },
    {
        "username": "sdfasdf",
        "score": 160
    },
    {
        "username": "dsfgdsfg",
        "score": 160
    },
    {
        "username": "Maari",
        "score": 160
    },
    {
        "username": "snowsunshine",
        "score": 160
    },
    {
        "username": "surbhi_gupta08",
        "score": 160
    },
    {
        "username": "OB1KenOB",
        "score": 160
    },
    {
        "username": "Rahul",
        "score": 150
    },
    {
        "username": "bjbnkj",
        "score": 140
    },
    {
        "username": "Sa0306",
        "score": 140
    },
    {
        "username": "DHester1",
        "score": 140
    },
    {
        "username": "Kottarathil",
        "score": 120
    },
    {
        "username": "FlawedWaffle",
        "score": 120
    },
    {
        "username": "Rainapplpinebow",
        "score": 120
    },
    {
        "username": "Balram",
        "score": 120
    },
    {
        "username": "Shravan",
        "score": 120
    },
    {
        "username": "shepherd",
        "score": 120
    },
    {
        "username": "ses",
        "score": 120
    },
    {
        "username": "Charan.224",
        "score": 120
    },
    {
        "username": "fungames5015",
        "score": 120
    },
    {
        "username": "Bounce",
        "score": 120
    },
    {
        "username": "zinar7",
        "score": 120
    },
    {
        "username": "Outrunic",
        "score": 120
    },
    {
        "username": "potayomiyaw",
        "score": 100
    },
    {
        "username": "subhanu12",
        "score": 100
    },
    {
        "username": "Kamalesh_K",
        "score": 100
    },
    {
        "username": "Deacon210",
        "score": 100
    },
    {
        "username": "Saivenkat",
        "score": 100
    },
    {
        "username": "Danika",
        "score": 100
    },
    {
        "username": "Sanchit",
        "score": 100
    },
    {
        "username": "18BCB0142",
        "score": 100
    },
    {
        "username": "sushi",
        "score": 100
    },
    {
        "username": "lemonnuggets",
        "score": 100
    },
    {
        "username": "bhadragkm",
        "score": 100
    },
    {
        "username": "Mr.Panda",
        "score": 100
    },
    {
        "username": "hsinha",
        "score": 100
    },
    {
        "username": "Sushain1",
        "score": 100
    },
    {
        "username": "Ashwin",
        "score": 100
    },
    {
        "username": "Tanwerrt",
        "score": 100
    },
    {
        "username": "AyushM",
        "score": 100
    },
    {
        "username": "Bhavya.vaid",
        "score": 100
    },
    {
        "username": "MissErickaUK",
        "score": 100
    },
    {
        "username": "Kopke",
        "score": 100
    },
    {
        "username": "imagifight",
        "score": 100
    },
    {
        "username": "Turtle",
        "score": 100
    },
    {
        "username": "shreyasenthil",
        "score": 100
    },
    {
        "username": "yashsrivastava",
        "score": 100
    },
    {
        "username": "20dec002_prashant",
        "score": 100
    },
    {
        "username": "nerdy",
        "score": 100
    },
    {
        "username": "sharesus",
        "score": 100
    },
    {
        "username": "shewaramani",
        "score": 100
    },
    {
        "username": "Rithika31",
        "score": 100
    },
    {
        "username": "arty@69",
        "score": 100
    },
    {
        "username": "WildThumb",
        "score": 100
    },
    {
        "username": "apoCalypso",
        "score": 100
    },
    {
        "username": "Kaylesxdevine",
        "score": 100
    },
    {
        "username": "Arjeet27",
        "score": 100
    },
    {
        "username": "shubh02",
        "score": 100
    },
    {
        "username": "MehulSharma0911",
        "score": 100
    },
    {
        "username": "shahz",
        "score": 100
    },
    {
        "username": "_shadowray_",
        "score": 100
    },
    {
        "username": "idc123",
        "score": 100
    },
    {
        "username": "bfgdb",
        "score": 100
    },
    {
        "username": "Sushain",
        "score": 100
    },
    {
        "username": "tannmoy_12",
        "score": 100
    },
    {
        "username": "PyroSama",
        "score": 100
    },
    {
        "username": "naman",
        "score": 100
    },
    {
        "username": "Agnieszka",
        "score": 100
    },
    {
        "username": "poggerschamper",
        "score": 100
    },
    {
        "username": "seaweed",
        "score": 100
    },
    {
        "username": "heavy_driver",
        "score": 100
    },
    {
        "username": "kalp1212",
        "score": 100
    },
    {
        "username": "kedicik",
        "score": 100
    },
    {
        "username": "SpaceAxolotl",
        "score": 100
    },
    {
        "username": "Theodaniel",
        "score": 100
    },
    {
        "username": "BlackJack",
        "score": 100
    },
    {
        "username": "aaryankothariiii",
        "score": 100
    },
    {
        "username": "Svgeboi!",
        "score": 100
    },
    {
        "username": "mottacurry",
        "score": 100
    },
    {
        "username": "dishagoyal__",
        "score": 100
    },
    {
        "username": "ra123",
        "score": 100
    },
    {
        "username": "cosmos",
        "score": 100
    },
    {
        "username": "Fabian",
        "score": 100
    },
    {
        "username": "rotom",
        "score": 100
    },
    {
        "username": "Arthur_Pendraig",
        "score": 80
    },
    {
        "username": "srini",
        "score": 80
    },
    {
        "username": "textrant",
        "score": 80
    },
    {
        "username": "Va0306",
        "score": 80
    },
    {
        "username": "inversevijay",
        "score": 80
    },
    {
        "username": "matcauthon49",
        "score": 60
    },
    {
        "username": "DsP_1432",
        "score": 60
    },
    {
        "username": "chirag_goenka",
        "score": 60
    },
    {
        "username": "AtullKrishnan",
        "score": 60
    },
    {
        "username": "aatmanrp",
        "score": 60
    },
    {
        "username": "ABILASH",
        "score": 60
    },
    {
        "username": "Kanishkaa___",
        "score": 60
    },
    {
        "username": "AInvader",
        "score": 60
    },
    {
        "username": "nicks05",
        "score": 60
    },
    {
        "username": "Clown",
        "score": 60
    },
    {
        "username": "nakul",
        "score": 60
    },
    {
        "username": "whoisaditya",
        "score": 60
    },
    {
        "username": "abhist_55",
        "score": 60
    },
    {
        "username": "Kris.Dsz",
        "score": 60
    },
    {
        "username": "hrshhhhhhhh",
        "score": 60
    },
    {
        "username": "Kaushikreddy",
        "score": 60
    },
    {
        "username": "MrFelonVG",
        "score": 60
    },
    {
        "username": "Aman",
        "score": 60
    },
    {
        "username": "Blain",
        "score": 60
    },
    {
        "username": "Bonda",
        "score": 60
    },
    {
        "username": "pipedream",
        "score": 60
    },
    {
        "username": "Siddhant",
        "score": 60
    },
    {
        "username": "akash110599",
        "score": 60
    },
    {
        "username": "Anaa",
        "score": 60
    },
    {
        "username": "creator_89",
        "score": 60
    },
    {
        "username": "Cipher01",
        "score": 60
    },
    {
        "username": "Dhruv_A",
        "score": 60
    },
    {
        "username": "tyroelite",
        "score": 60
    },
    {
        "username": "TudorO",
        "score": 60
    },
    {
        "username": "namitjainx",
        "score": 60
    },
    {
        "username": "TurnedHod",
        "score": 60
    },
    {
        "username": "ddhere",
        "score": 60
    },
    {
        "username": "Hardik19",
        "score": 60
    },
    {
        "username": "Gggbhg",
        "score": 60
    },
    {
        "username": "nitishrg",
        "score": 60
    },
    {
        "username": "safdsfasa",
        "score": 60
    },
    {
        "username": "relddir",
        "score": 60
    },
    {
        "username": "fortnite_pogers_201",
        "score": 60
    },
    {
        "username": "theoneandonly",
        "score": 60
    },
    {
        "username": "anarchistmaster",
        "score": 60
    },
    {
        "username": "shadoeray",
        "score": 60
    },
    {
        "username": "Overseer",
        "score": 60
    },
    {
        "username": "Yash_The_Great",
        "score": 60
    },
    {
        "username": "blah-blah-blacksheep",
        "score": 60
    },
    {
        "username": "john",
        "score": 60
    },
    {
        "username": "teodork596",
        "score": 60
    },
    {
        "username": "Raz",
        "score": 60
    },
    {
        "username": "Batsy",
        "score": 60
    },
    {
        "username": "Swag-sen",
        "score": 60
    },
    {
        "username": "guest0431",
        "score": 60
    },
    {
        "username": "sauravmh",
        "score": 60
    },
    {
        "username": "Rtanwer",
        "score": 60
    },
    {
        "username": "bonsaiKitten456",
        "score": 60
    },
    {
        "username": "gayatri",
        "score": 60
    },
    {
        "username": "desai",
        "score": 60
    },
    {
        "username": "johnappleseed",
        "score": 60
    },
    {
        "username": "kp_xvii",
        "score": 60
    },
    {
        "username": "Manav",
        "score": 0
    },
    {
        "username": "Sc0rp10n.py",
        "score": 0
    },
    {
        "username": "Udita123",
        "score": 0
    },
    {
        "username": "shadowji",
        "score": 0
    },
    {
        "username": "anoushka",
        "score": 0
    },
    {
        "username": "mincewaft27",
        "score": 0
    },
    {
        "username": "thejasoy",
        "score": 0
    },
    {
        "username": "macarani",
        "score": 0
    },
    {
        "username": "Yuvraj02",
        "score": 0
    },
    {
        "username": "iparvez",
        "score": 0
    },
    {
        "username": "mrinalagarwal",
        "score": 0
    },
    {
        "username": "bobbob11234",
        "score": 0
    },
    {
        "username": "KunalKulkarni",
        "score": 0
    },
    {
        "username": "Reo",
        "score": 0
    },
    {
        "username": "kunnduu",
        "score": 0
    },
    {
        "username": "samvid_1907",
        "score": 0
    },
    {
        "username": "samiksha_29",
        "score": 0
    },
    {
        "username": "Dev06",
        "score": 0
    },
    {
        "username": "vishnu99vardhan",
        "score": 0
    },
    {
        "username": "Sam",
        "score": 0
    },
    {
        "username": "VisheshBansal",
        "score": 0
    },
    {
        "username": "kshubham0411",
        "score": 0
    },
    {
        "username": "bOT",
        "score": 0
    },
    {
        "username": "Vedant12345",
        "score": 0
    },
    {
        "username": "ananya",
        "score": 0
    },
    {
        "username": "Pseudo",
        "score": 0
    },
    {
        "username": "InfiniteProphet",
        "score": 0
    },
    {
        "username": "assxss1n",
        "score": 0
    },
    {
        "username": "SauravBaid",
        "score": 0
    },
    {
        "username": "Absolute3",
        "score": 0
    },
    {
        "username": "sevmarc",
        "score": 0
    },
    {
        "username": "_dakshin_43",
        "score": 0
    },
    {
        "username": "suddu",
        "score": 0
    },
    {
        "username": "LegionFZ",
        "score": 0
    },
    {
        "username": "abivarshh",
        "score": 0
    },
    {
        "username": "DiluteWater",
        "score": 0
    },
    {
        "username": "aneeshpanda",
        "score": 0
    },
    {
        "username": "Idkwhoami",
        "score": 0
    },
    {
        "username": "Janavi",
        "score": 0
    },
    {
        "username": "shubhankar007",
        "score": 0
    },
    {
        "username": "priprisauce",
        "score": 0
    },
    {
        "username": "Gautham",
        "score": 0
    },
    {
        "username": "jayant_rao._",
        "score": 0
    },
    {
        "username": "akanksha.goel",
        "score": 0
    },
    {
        "username": "CH1NRU5T",
        "score": 0
    },
    {
        "username": "EshanGupta1925",
        "score": 0
    },
    {
        "username": "Arjunlol",
        "score": 0
    },
    {
        "username": "mdadhib",
        "score": 0
    },
    {
        "username": "sanjay",
        "score": 0
    },
    {
        "username": "ashish",
        "score": 0
    },
    {
        "username": "Somya",
        "score": 0
    },
    {
        "username": "Edison!@124",
        "score": 0
    },
    {
        "username": "19BCE0859",
        "score": 0
    },
    {
        "username": "sid",
        "score": 0
    },
    {
        "username": "kyun.lakshay",
        "score": 0
    },
    {
        "username": "cr_trojan23",
        "score": 0
    },
    {
        "username": "varshabhat",
        "score": 0
    },
    {
        "username": "rahilkabani",
        "score": 0
    },
    {
        "username": "roerohan",
        "score": 0
    },
    {
        "username": "kajal",
        "score": 0
    },
    {
        "username": "devashar",
        "score": 0
    },
    {
        "username": "siddharthray",
        "score": 0
    },
    {
        "username": "nameless",
        "score": 0
    },
    {
        "username": "Aaditya_Kumra",
        "score": 0
    },
    {
        "username": "tealnshack",
        "score": 0
    },
    {
        "username": "riyacsi",
        "score": 0
    },
    {
        "username": "BhoomikaHosur",
        "score": 0
    },
    {
        "username": "dbksmemes",
        "score": 0
    },
    {
        "username": "TonyBA",
        "score": 0
    },
    {
        "username": "sbf19",
        "score": 0
    },
    {
        "username": "AdityaBoral03",
        "score": 0
    },
    {
        "username": "anushka_30",
        "score": 0
    },
    {
        "username": "ps23",
        "score": 0
    },
    {
        "username": "Kishan",
        "score": 0
    },
    {
        "username": "Kumar",
        "score": 0
    },
    {
        "username": "Raine",
        "score": 0
    },
    {
        "username": "Sako",
        "score": 0
    },
    {
        "username": "Imranlezghou",
        "score": 0
    },
    {
        "username": "trashcodagama",
        "score": 0
    },
    {
        "username": "theblackhat",
        "score": 0
    },
    {
        "username": "anu",
        "score": 0
    },
    {
        "username": "Mahi03",
        "score": 0
    },
    {
        "username": "Samyammm",
        "score": 0
    },
    {
        "username": "Chembai",
        "score": 0
    },
    {
        "username": "Armernon",
        "score": 0
    },
    {
        "username": "Dwaipayan26",
        "score": 0
    },
    {
        "username": "Vinayak21",
        "score": 0
    },
    {
        "username": "Pragati",
        "score": 0
    },
    {
        "username": "GothamCitY",
        "score": 0
    },
    {
        "username": "Archit1307",
        "score": 0
    },
    {
        "username": "Sab.03",
        "score": 0
    },
    {
        "username": "p.karim_khan",
        "score": 0
    },
    {
        "username": "prat",
        "score": 0
    },
    {
        "username": "dsrikar7@gmail.com",
        "score": 0
    },
    {
        "username": "ThisRandomDude",
        "score": 0
    },
    {
        "username": "mahaa",
        "score": 0
    },
    {
        "username": "zombiemangol28",
        "score": 0
    },
    {
        "username": "Kookie",
        "score": 0
    },
    {
        "username": "Harsh1611",
        "score": 0
    },
    {
        "username": "TannyG",
        "score": 0
    },
    {
        "username": "Loki",
        "score": 0
    },
    {
        "username": "Devansh_Mudgal",
        "score": 0
    },
    {
        "username": "SUBRAMANIAN1@",
        "score": 0
    },
    {
        "username": "nyx0000",
        "score": 0
    },
    {
        "username": "harryies",
        "score": 0
    },
    {
        "username": "PS1607",
        "score": 0
    },
    {
        "username": "NeXo",
        "score": 0
    },
    {
        "username": "rohith._.3093",
        "score": 0
    },
    {
        "username": "Sakshimahawar",
        "score": 0
    },
    {
        "username": "Aqibb",
        "score": 0
    },
    {
        "username": "gaganbhatia",
        "score": 0
    },
    {
        "username": "rithvik2310",
        "score": 0
    },
    {
        "username": "sanketb7",
        "score": 0
    },
    {
        "username": "Rushabh",
        "score": 0
    },
    {
        "username": "Abhishek",
        "score": 0
    },
    {
        "username": "Steph_07",
        "score": 0
    },
    {
        "username": "Maitreyi1506",
        "score": 0
    },
    {
        "username": "Simrankhurana",
        "score": 0
    },
    {
        "username": "Tushar",
        "score": 0
    },
    {
        "username": "PureStealth14",
        "score": 0
    },
    {
        "username": "20BIT0247",
        "score": 0
    },
    {
        "username": "shmkmr",
        "score": 0
    },
    {
        "username": "Bhu_23",
        "score": 0
    },
    {
        "username": "Aviral",
        "score": 0
    },
    {
        "username": "Rushil30",
        "score": 0
    },
    {
        "username": "Sam007",
        "score": 0
    },
    {
        "username": "Icy_comm",
        "score": 0
    },
    {
        "username": "Sugansundar",
        "score": 0
    },
    {
        "username": "FuzzyPanda",
        "score": 0
    },
    {
        "username": "Himerius",
        "score": 0
    },
    {
        "username": "Swethaa",
        "score": 0
    },
    {
        "username": "anushagarg",
        "score": 0
    },
    {
        "username": "yungj3rn",
        "score": 0
    },
    {
        "username": "Xeonzinc",
        "score": 0
    },
    {
        "username": "gurleen136",
        "score": 0
    },
    {
        "username": "alan@alanarthur.com",
        "score": 0
    },
    {
        "username": "Richa_Tekchandani",
        "score": 0
    },
    {
        "username": "ankit.singh",
        "score": 0
    },
    {
        "username": "kahuna",
        "score": 0
    },
    {
        "username": "awon1234",
        "score": 0
    },
    {
        "username": "velv",
        "score": 0
    },
    {
        "username": "codersaur",
        "score": 0
    },
    {
        "username": "TreiktO",
        "score": 0
    },
    {
        "username": "noob975",
        "score": 0
    },
    {
        "username": "CardboardHead",
        "score": 0
    },
    {
        "username": "Eshika",
        "score": 0
    },
    {
        "username": "Gorbzilla",
        "score": 0
    },
    {
        "username": "adik",
        "score": 0
    },
    {
        "username": "Smash",
        "score": 0
    },
    {
        "username": "manasvvi1",
        "score": 0
    },
    {
        "username": "arivera3483",
        "score": 0
    },
    {
        "username": "Eternally_basic",
        "score": 0
    },
    {
        "username": "PearlShah",
        "score": 0
    },
    {
        "username": "derb",
        "score": 0
    },
    {
        "username": "cpt_pickle23",
        "score": 0
    },
    {
        "username": "kundan.2909",
        "score": 0
    },
    {
        "username": "lia",
        "score": 0
    },
    {
        "username": "Aedon",
        "score": 0
    },
    {
        "username": "parikshit22",
        "score": 0
    },
    {
        "username": "ishitttaaa",
        "score": 0
    },
    {
        "username": "juxceee",
        "score": 0
    },
    {
        "username": "nita",
        "score": 0
    },
    {
        "username": "RaZiel2708",
        "score": 0
    },
    {
        "username": "Robin888",
        "score": 0
    },
    {
        "username": "alireza1386",
        "score": 0
    },
    {
        "username": "Kattel",
        "score": 0
    },
    {
        "username": "SK47",
        "score": 0
    },
    {
        "username": "bec01300130",
        "score": 0
    },
    {
        "username": "Vinith_j",
        "score": 0
    },
    {
        "username": "scribbletoes",
        "score": 0
    },
    {
        "username": "Varsini",
        "score": 0
    },
    {
        "username": "saswatabasu23",
        "score": 0
    },
    {
        "username": "ayankhan20",
        "score": 0
    },
    {
        "username": "Potato242",
        "score": 0
    },
    {
        "username": "Gauri",
        "score": 0
    },
    {
        "username": "AnnMarry",
        "score": 0
    },
    {
        "username": "Dalal",
        "score": 0
    },
    {
        "username": "pragati1610",
        "score": 0
    },
    {
        "username": "mikeweb84",
        "score": 0
    },
    {
        "username": "cygnus",
        "score": 0
    },
    {
        "username": "Van",
        "score": 0
    },
    {
        "username": "Soni",
        "score": 0
    },
    {
        "username": "sachin",
        "score": 0
    },
    {
        "username": "bysani2003",
        "score": 0
    },
    {
        "username": "19bce1754",
        "score": 0
    },
    {
        "username": "kuttupani",
        "score": 0
    },
    {
        "username": "The_Endurance",
        "score": 0
    },
    {
        "username": "Prannav",
        "score": 0
    },
    {
        "username": "sharmakrishna",
        "score": 0
    },
    {
        "username": "ameyaranade",
        "score": 0
    },
    {
        "username": "MrsLobster",
        "score": 0
    },
    {
        "username": "Nyx",
        "score": 0
    },
    {
        "username": "mintcream",
        "score": 0
    },
    {
        "username": "AadityaPareek",
        "score": 0
    },
    {
        "username": "Ankit1",
        "score": 0
    },
    {
        "username": "Samhitha",
        "score": 0
    },
    {
        "username": "ILAM115",
        "score": 0
    },
    {
        "username": "Sruti",
        "score": 0
    },
    {
        "username": "Falcon",
        "score": 0
    },
    {
        "username": "nanditapal2511",
        "score": 0
    },
    {
        "username": "Shinzo",
        "score": 0
    },
    {
        "username": "professor",
        "score": 0
    },
    {
        "username": "sakshi_kst",
        "score": 0
    },
    {
        "username": "dkara",
        "score": 0
    },
    {
        "username": "Mhetre__AyuSh",
        "score": 0
    },
    {
        "username": "dungeon_master",
        "score": 0
    },
    {
        "username": "Carranthia",
        "score": 0
    },
    {
        "username": "gaurang20",
        "score": 0
    },
    {
        "username": "kashish",
        "score": 0
    },
    {
        "username": "illyria504",
        "score": 0
    },
    {
        "username": "msachan562000",
        "score": 0
    },
    {
        "username": "Ak206",
        "score": 0
    },
    {
        "username": "helloworld",
        "score": 0
    },
    {
        "username": "ankitam",
        "score": 0
    },
    {
        "username": "johntony366",
        "score": 0
    },
    {
        "username": "om_raj_000",
        "score": 0
    },
    {
        "username": "20BIT0158",
        "score": 0
    },
    {
        "username": "Statrox",
        "score": 0
    },
    {
        "username": "AmitPriyadarshi",
        "score": 0
    },
    {
        "username": "Varnana",
        "score": 0
    },
    {
        "username": "1eXray",
        "score": 0
    },
    {
        "username": "Voltox",
        "score": 0
    },
    {
        "username": "sugona",
        "score": 0
    },
    {
        "username": "test23",
        "score": 0
    },
    {
        "username": "Cool",
        "score": 0
    },
    {
        "username": "iamthedevil",
        "score": 0
    },
    {
        "username": "tranzalore",
        "score": 0
    },
    {
        "username": "tangabali_padukone",
        "score": 0
    },
    {
        "username": "sabs",
        "score": 0
    },
    {
        "username": "shwetansh_srii",
        "score": 0
    },
    {
        "username": "radha.arakkal1510",
        "score": 0
    },
    {
        "username": "vidhumital",
        "score": 0
    },
    {
        "username": "SanjayKumar",
        "score": 0
    },
    {
        "username": "newt_tu",
        "score": 0
    },
    {
        "username": "Thahiba",
        "score": 0
    },
    {
        "username": "janeccerek",
        "score": 0
    },
    {
        "username": "xdevam",
        "score": 0
    },
    {
        "username": "MarcZenitsu74",
        "score": 0
    },
    {
        "username": "hemaaaa",
        "score": 0
    },
    {
        "username": "Revolverina",
        "score": 0
    },
    {
        "username": "wamblybanjo",
        "score": 0
    },
    {
        "username": "Rachana.jestadi",
        "score": 0
    },
    {
        "username": "clover-is-plant",
        "score": 0
    },
    {
        "username": "Jill",
        "score": 0
    },
    {
        "username": "trishnasharma",
        "score": 0
    },
    {
        "username": "aarush",
        "score": 0
    },
    {
        "username": "Rohan",
        "score": 0
    },
    {
        "username": "amankuvera",
        "score": 0
    },
    {
        "username": "gurveenzbored",
        "score": 0
    },
    {
        "username": "Kay69",
        "score": 0
    },
    {
        "username": "Akash",
        "score": 0
    },
    {
        "username": "Chronomyst",
        "score": 0
    },
    {
        "username": "Ajit",
        "score": 0
    },
    {
        "username": "Mayank069",
        "score": 0
    },
    {
        "username": "Tray_Arip",
        "score": 0
    },
    {
        "username": "Irah",
        "score": 0
    },
    {
        "username": "Vishal7169",
        "score": 0
    },
    {
        "username": "Lansdown12",
        "score": 0
    },
    {
        "username": "fsadfas",
        "score": 0
    },
    {
        "username": "mattyknowsit",
        "score": 0
    },
    {
        "username": "Sarbani23",
        "score": 0
    },
    {
        "username": "user_name",
        "score": 0
    },
    {
        "username": "insert_user_name",
        "score": 0
    },
    {
        "username": "archisha007",
        "score": 0
    },
    {
        "username": "Lohitha_27",
        "score": 0
    },
    {
        "username": "robotkobold",
        "score": 0
    },
    {
        "username": "Snow",
        "score": 0
    },
    {
        "username": "ekarsilodh",
        "score": 0
    },
    {
        "username": "amrita",
        "score": 0
    },
    {
        "username": "willmarion22",
        "score": 0
    },
    {
        "username": "mihi06",
        "score": 0
    },
    {
        "username": "shivamsoni",
        "score": 0
    },
    {
        "username": "Pali",
        "score": 0
    },
    {
        "username": "rodog2661",
        "score": 0
    },
    {
        "username": "alphavp",
        "score": 0
    },
    {
        "username": "gursehajdapeo69",
        "score": 0
    },
    {
        "username": "m31nth3c0rn3r",
        "score": 0
    },
    {
        "username": "Samanvitha",
        "score": 0
    },
    {
        "username": "mynk25",
        "score": 0
    },
    {
        "username": "FoG-MK",
        "score": 0
    },
    {
        "username": "20BCE2801",
        "score": 0
    },
    {
        "username": "Flashman21",
        "score": 0
    },
    {
        "username": "sharathguvvala",
        "score": 0
    },
    {
        "username": "prakashbari",
        "score": 0
    },
    {
        "username": "Sujii",
        "score": 0
    },
    {
        "username": "mananmathurr",
        "score": 0
    },
    {
        "username": "YogeshPatil",
        "score": 0
    },
    {
        "username": "neelamtanwar",
        "score": 0
    },
    {
        "username": "Ntanwer",
        "score": 0
    },
    {
        "username": "Dretek",
        "score": 0
    },
    {
        "username": "Anisha.1010",
        "score": 0
    },
    {
        "username": "isha",
        "score": 0
    },
    {
        "username": "SunbeaM",
        "score": 0
    },
    {
        "username": "D4C:LT",
        "score": 0
    },
    {
        "username": "GauriPradeep",
        "score": 0
    },
    {
        "username": "sid_k_s",
        "score": 0
    },
    {
        "username": "Prat",
        "score": 0
    },
    {
        "username": "Greg",
        "score": 0
    },
    {
        "username": "Izahg",
        "score": 0
    },
    {
        "username": "20BCE0923",
        "score": 0
    },
    {
        "username": "sputnik",
        "score": 0
    },
    {
        "username": "thebongy",
        "score": 0
    },
    {
        "username": "NingNing242",
        "score": 0
    },
    {
        "username": "samarthgupta19",
        "score": 0
    },
    {
        "username": "Amith",
        "score": 0
    },
    {
        "username": "jaydeep.thakkar",
        "score": 0
    },
    {
        "username": "siddharth",
        "score": 0
    },
    {
        "username": "WooHoo451",
        "score": 0
    },
    {
        "username": "shaarangg",
        "score": 0
    },
    {
        "username": "ytanyadora",
        "score": 0
    },
    {
        "username": "prashna",
        "score": 0
    },
    {
        "username": "Anivini",
        "score": 0
    },
    {
        "username": "baniya",
        "score": 0
    },
    {
        "username": "rakesh",
        "score": 0
    },
    {
        "username": "lordoftheping",
        "score": 0
    },
    {
        "username": "Avineesh",
        "score": 0
    },
    {
        "username": "kadambari03",
        "score": 0
    },
    {
        "username": "sventse",
        "score": 0
    },
    {
        "username": "sshivansh_sharma",
        "score": 0
    },
    {
        "username": "astha",
        "score": 0
    },
    {
        "username": "AtomikSingularity",
        "score": 0
    },
    {
        "username": "RaWon",
        "score": 0
    },
    {
        "username": "Wolfstar",
        "score": 0
    },
    {
        "username": "whitestarline3",
        "score": 0
    },
    {
        "username": "rishitshivesh",
        "score": 0
    },
    {
        "username": "Zoziox",
        "score": 0
    },
    {
        "username": "priyansh19",
        "score": 0
    },
    {
        "username": "Manav999",
        "score": 0
    },
    {
        "username": "Madhursarathe",
        "score": 0
    },
    {
        "username": "Xyln",
        "score": 0
    },
    {
        "username": "Nahan",
        "score": 0
    },
    {
        "username": "Jessielm15",
        "score": 0
    },
    {
        "username": "Mfteague15@gmail.com",
        "score": 0
    },
    {
        "username": "archanabkn",
        "score": 0
    },
    {
        "username": "jkrrish001",
        "score": 0
    },
    {
        "username": "jatinsanghvi",
        "score": 0
    },
    {
        "username": "Markn5997",
        "score": 0
    },
    {
        "username": "proton",
        "score": 0
    },
    {
        "username": "leojmatt",
        "score": 0
    },
    {
        "username": "Achinthya",
        "score": 0
    },
    {
        "username": "Inquisitive",
        "score": 0
    },
    {
        "username": "ZephyrusX",
        "score": 0
    },
    {
        "username": "akshara",
        "score": 0
    },
    {
        "username": "shrav",
        "score": 0
    },
    {
        "username": "AlphaRend",
        "score": 0
    },
    {
        "username": "ANNAJJ",
        "score": 0
    },
    {
        "username": "Radosavljevic",
        "score": 0
    },
    {
        "username": "andymarlow",
        "score": 0
    },
    {
        "username": "Garry_02",
        "score": 0
    },
    {
        "username": "sherlocked",
        "score": 0
    },
    {
        "username": "ronny",
        "score": 0
    },
    {
        "username": "flylikeanabi",
        "score": 0
    },
    {
        "username": "bhavya_candy",
        "score": 0
    },
    {
        "username": "DarshK",
        "score": 0
    },
    {
        "username": "It'sanket",
        "score": 0
    },
    {
        "username": "Cudiamat",
        "score": 0
    },
    {
        "username": "Muazz45",
        "score": 0
    },
    {
        "username": "Grim",
        "score": 0
    },
    {
        "username": "DuckyMomo",
        "score": 0
    },
    {
        "username": "Shreeya13",
        "score": 0
    },
    {
        "username": "cyclonite",
        "score": 0
    },
    {
        "username": "Sidemir_",
        "score": 0
    },
    {
        "username": "kevinbaker017",
        "score": 0
    },
    {
        "username": "arpitk",
        "score": 0
    },
    {
        "username": "rsaraf97",
        "score": 0
    },
    {
        "username": "lakshya13",
        "score": 0
    },
    {
        "username": "Hashgag",
        "score": 0
    },
    {
        "username": "Baggan",
        "score": 0
    },
    {
        "username": "Wla53",
        "score": 0
    },
    {
        "username": "Rob99",
        "score": 0
    },
    {
        "username": "fash2002",
        "score": 0
    },
    {
        "username": "CarolineH",
        "score": 0
    },
    {
        "username": "kainfury",
        "score": 0
    },
    {
        "username": "SarlCagan93",
        "score": 0
    },
    {
        "username": "bigBootyMama",
        "score": 0
    },
    {
        "username": "lin05",
        "score": 0
    }
]